module.exports = __webpack_public_path__ + "static/media/08.e6299b29.jpg";